// app/routes/$.tsx
import { json, LoaderFunction, LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { Link } from "@remix-run/react";
import { IconArrowLeft } from "@tabler/icons-react";

import ErrorIllustration from "~/assets/misc/404-illustration.svg?react";
import { PAGE_TITLE } from "~/constants";
import { useTranslation } from "~/hooks/use-typed-translation";
import i18next from "~/localization/i18n.server";
import utilityClasses from "~/styles/utilities.module.scss";

import classes from "./not-found.module.scss";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return [
    { title: data?.title },
    { property: "og:title", content: data?.title },
  ];
};

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <section className={classes.section}>
      <div style={{ height: "100%" }} className={utilityClasses.container}>
        <div className={classes.content}>
          <ErrorIllustration className={classes.illustration} />
          <div className={classes["text-content"]}>
            <h1>{t("not-found-title")}</h1>
            <p>
              {t("not-found-description")}{" "}
              <Link to="tel:+2250502876887">+225 05 02 87 68 87</Link> •{" "}
              <Link to="mailto:engineering@laruche.health">
                engineering@laruche.health
              </Link>
            </p>

            <Link to={"/"} className={classes.cta}>
              <IconArrowLeft />
              <span>{t("go-back")}</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export async function loader({ request, params }: LoaderFunctionArgs) {
  const lang = params.lang as string | undefined;
  const locale = lang ?? (await i18next.getLocale(request));

  // * NB: Translation doesn't work for meta tags after deployment
  const text = locale === "fr" ? "Page non trouvée" : "Page not found";

  const title = `${text} • ${PAGE_TITLE}`;
  return json({ title });
}
